import { render, staticRenderFns } from "./DialogLimiteCompra.vue?vue&type=template&id=d25de64e&"
import script from "./DialogLimiteCompra.vue?vue&type=script&lang=js&"
export * from "./DialogLimiteCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports